import React, { Component } from "react";
import styles from "./styles";
import { actions } from "./actions";
import store from "./store";
import { Button, TextField, withStyles, Grid } from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import VirtualList from "react-tiny-virtual-list";
import axios from "axios";
const url = process.env.REACT_APP_WIDGET_API;

class Airport extends Component {

  state = {
  showList: false,
  Origin: '',
  Destination: '',
  airports: [],
  originOptions: [], // unique origins
  destinationOptions: [] // filtered destinations
};

  id = `AirportInput`;
  state = {
    showList: false,
    Origin: '',
    Destination: ''
  };

  
componentDidMount() {
  const flightDate = '03AUG';
  const airlineName = 'TradewindAviation';
  const flightNumber = 'TJ001';

  axios.get(`${url}/getAirports`, {
    params: { flightDate, airlineName, flightNumber }
  })
    .then(response => {
      const airports = response.data;

      // Get unique origins from the `depart` field
      const seen = new Set();
      const originOptions = airports
        .filter(({ depart }) => {
          if (seen.has(depart)) return false;
          seen.add(depart);
          return true;
        })
        .map(({ depart, DepartAirportName }) => ({
          iata: depart,
          name: DepartAirportName || depart
        }));

      this.setState({
        airports,
        originOptions
      });
    })
    .catch(error => {
      console.error('Failed to load airports:', error);
    });
}




  _onClick = () => {
    document.addEventListener(`click`, this._clickAway);
    this.setState({ showList: true });
  };

  _clickAway = (ev) => {
    if (ev.target.closest(`#AirportInput`)) return;

    document.removeEventListener(`click`, this._clickAway);
    this.setState({ showList: false });
  };

selectAirport = (airport) => () => {
  if (this.props.type === 'Origin') {
    const destinations = this.state.airports
  .filter(route => route.depart === airport.iata)
  .map(route => ({
    iata: route.destin,
    name: route.DestinAirportName || route.destin
  }));


    this.setState({
      Origin: airport.iata,
      showList: false,
      destinationOptions: destinations
    });

    store.dispatch(actions.originFilter(airport.iata));
    store.dispatch(actions.destinationOptions(destinations)); // ✅ add this
    console.log("Selected origin:", airport.iata);
    console.log("Available destinations:", destinations);

  } else {
    this.setState({ Destination: airport.iata, showList: false });
    store.dispatch(actions.destinationFilter(airport.iata));
  }
};




  handleAirportChange = ({ target }) => {
    const value = target.value.toUpperCase();
    if (this.props.type === 'Origin') {
      this.setState({ Origin: value})
      store.dispatch(actions.originFilter(value));
    } else {
      this.setState({ Destination: value})
      store.dispatch(actions.destinationFilter(value));
    }
  };

  render() {
    const { classes, type } = this.props;
    // let _list = [
    //   { name: "Antigua", iata: "ANU" },
    //   { name: "Marthas Vineyard", iata: "MVY" },
    //   { name: "Nantucket", iata: "ACK" },
    //   { name: "San Juan", iata: "SJU" },
    //   { name: "St Barths", iata: "SBH" },
    //   { name: "Teterboro", iata: "TEB" },
    //   { name: "Westchester County", iata: "HPN" },
    // ];

    // let _list = [
    //   { name: "Antigua", iata: "ANU" },
    //   { name: "Marthas Vineyard", iata: "MVY" },
    //   { name: "Nantucket", iata: "ACK" },
    //   { name: "San Juan", iata: "SJU" },
    //   { name: "St Barths", iata: "SBH" },
    //   { name: "Teterboro", iata: "TEB" },
    //   { name: "Westchester County", iata: "HPN" },
    //   { name: "Anguilla", iata: "AXA" },
    //   { name: "Marsh Harbour", iata: "MHH" },
    //   { name: "North Eleuthera", iata: "ELH" },
    //   { name: "Palm Beach", iata: "PBI" },
    //   { name: "Stuart", iata: "SUA" },
    //   { name: "St. Thomas", iata: "STT" },
    //   { name: "Tortola", iata: "EIS" },
    //   { name: "Virgin Gorda", iata: "VIJ" }
    // ];
const reduxState = store.getState();

let _list = this.props.type === 'Origin'
  ? this.state.originOptions
  : reduxState.destinationOptions || [];



    let helper = type === 'Origin' ? 'Choose an Origin to see all flights from that location' : 'Choose an Origin and Destination to see specific routing';
    return (
      <Grid item xs={12} md={4} className={classes.input}>
        <TextField
          label={type}
          variant="outlined"
          onChange={this.handleAirportChange}
          onClick={this._onClick}
          margin="dense"
          helperText={helper}
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={this.state[type]}
        />
        <Fade in={this.state.showList} unmountOnExit>
          <List component="nav" dense className={classes.list}>
            <VirtualList
              itemCount={(_list || []).length}
              itemSize={50}
              renderItem={({ style, index }) => {
                const item = _list[index];

                return (
                  <ListItem
                    title={item.name}
                    button
                    style={style}
                    onClick={this.selectAirport(item)}
                    key={index}
                  >
                    <ListItemText
                      primaryTypographyProps={{ noWrap: true }}
                      primary={item.name}
                      secondary={item.iata}
                    />
                  </ListItem>
                );
              }}
              className={classes.searchDropDown}
              overscanCount={30}
            />
          </List>
        </Fade>
      </Grid>
    );
  }
}

export default withStyles(styles)(Airport)


// WEBPACK FOOTER //
// ./src/widgets/FlightStatus/Airport.js